module.exports = __webpack_public_path__ + "static/media/YOTAP LOGO FULL.a37def91.png";